import React, { Fragment, useEffect, useState } from 'react';
import Banner from './Banner';
import InvoicePointVision from './InvoicePointVision';
import InlineInvoiceDemo from './InlineInvoiceDemo';
import Benefits from './Benefits';
import OurFeatures from './OurFeatures';
import SocialProofStats from './SocialProofStats';
import Testimonial from './Testimonial';
import IntegrationLogos from './IntegrationLogos';
import TryInvoice from './TryInvoice';
import Trial from './Trial';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

function HomeMain(){
    const { t, locale } = useLocale();

    const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1000)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.homeTitle')} description={t('meta.homeDescription')} path="/" locale={locale} />
            <Banner />
            <SocialProofStats />
            <InlineInvoiceDemo />
            <InvoicePointVision />
            <OurFeatures />
            <IntegrationLogos />
            <TryInvoice />
            <Benefits />
            <Testimonial />
            <Trial />
            <Footer />
        </Fragment>
    )
}

export default HomeMain;